<template>
  <div>
    <table id="carClass123">
      <thead>
        <tr>
          <td style="width: 100px;">车辆</td>
          <td>
            <span style="margin-right: 30px; margin-left: 15px">名称</span
            ><span style="margin-right: 180px">上班时间</span
            ><span style="margin-right: 50px">司机</span
            ><span style="margin-right: 120px">跟车</span>
            <span>操作</span>
          </td>
          <td v-if="false">操作</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(x, index) in item.carClasses" :key="index">
          <td style="width: 100px;">
            <select-car
              @car="x.carType = $event.carTypeName"
              :name="x.carNo"
              @update:name="x.carNo = $event"       
            >
            </select-car>
          </td>
          <!-- <td><Input v-model="x.manager" placeholder="请输入"></Input></td>
          <td><Input v-model="x.tel" placeholder="请输入"></Input></td> -->
          <td>
            <ul id="wewewe">
              <li
                class="clearfloat"
                v-for="(t, key) in x.classesList"
                :key="key"
              >
                <div class="asewec1">
                  <Input v-model="t.name"></Input>
                </div>
                <div class="asewec">
                  <div
                    class="asewec-child"
                    v-for="(m, index2) in t.timeList"
                    :key="index2"
                  >
                    <Select v-model="m.startTime">
                      <Option
                        v-for="(x, index) in $t('times')"
                        :value="x"
                        :key="index"
                        >{{ x }}</Option
                      >
                    </Select>
                    <span>至</span>
                    <Select v-model="m.endTime">
                      <Option
                        v-for="(x, index) in $t('times')"
                        :value="x"
                        :key="index"
                        >{{ x }}</Option
                      >
                    </Select>
                    <Button
                      @click="delClass(index, key, index2)"
                      :type="index2 == 0 ? 'success' : 'error'"
                      ghost
                      :icon="index2 == 0 ? 'md-add' : 'md-close'"
                    ></Button>
                  </div>
                </div>
                <div class="asewec123">
                  <Input
                    v-model="t.driver"
                    style="margin-right: 10px; width: 100px"
                  ></Input>
                  <Input v-model="t.follower"></Input>
                </div>
                <div class="asewec2">
                  <Button @click="delddd(index, key)" type="text">{{
                    key == 0 ? "添加" : "删除"
                  }}</Button>
                </div>
              </li>
            </ul>
          </td>
          <td v-if="false">
            <a @click="delCarClass(index)">{{
              index == 0 ? "添加" : "删除"
            }}</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      item: {
        groupId: 0,
        deptId: 0,
        lineId: 0,
        carClasses: [
          {
            carNo: "",
            carType: "",
            classesList: [
              {
                name: "A班",
                driver: "",
                follower: "",
                timeList: [
                  {
                    startTime: "06:00",
                    endTime: "10:00",
                  },
                  {
                    startTime: "14:00",
                    endTime: "18:00",
                  },
                ],
              },
            ],
            manager: "",
            tel: "",
          },
        ],
      },
      ruleValidate: {
        startDate1: { required: true, message: "必填" },
        endDate1: { required: true, message: "必填" },
      },
    };
  },
  methods: {
    watchClass() {
      var aaa = this.item.carClasses[0].carNo.length;
      var bbb = this.item.carClasses[0].classesList[0].driver.length;
      var ccc = this.item.carClasses[0].classesList[0].follower.length;
      var ddd = this.item.carClasses[0].classesList[0].name.length;
      if (aaa > 0 && bbb > 0 && ccc > 0 && ddd > 0) {
        return true;
      } else {
        return false;
      }
    },
    reData(v) {
      this.item.lineId = v.lineId;
      this.item.deptId = v.deptId;
      this.item.groupId = v.groupId;
      console.log(this.item);
      this.saveCarClass();
    },
    saveCarClass() {
      console.log(this.item);
      axios({
        method: "post",
        url: axios.gc + "/schedule/add",
        data: this.item,
      }).then((res) => {
        console.log(res);
        if (res) {
          this.$emit("close");
        }
      });
    },
    getList(id) {
      //lineId
      axios({
        method: "post",
        url: axios.gc + "/schedule/list",
        data: { lineId: id },
      }).then((res) => {
        if (res) {
          console.log(res);
          var data = res.data.data.dataList;
          this.item.carClasses = [];
          for (let i = 0; i < data.length; i++) {
            this.item.carClasses.push(data[i].carClasses[0]);
          }
          console.log(this.item);
        }
      });
    },
    delCarClass(index) {
      console.log(index);
      if (index == 0) {
        this.addCarClass();
      } else {
        this.item.carClasses.splice(index, 1);
      }
    },
    delClass(index, key, index2) {
      if (index2 == 0) {
        this.addClass(index, key);
      } else {
        this.item.carClasses[index].classesList[key].timeList.splice(index2, 1);
      }
    },
    addClass(index, key) {
      var obj = { startTime: "09:00", endTime: "10:00" };
      this.item.carClasses[index].classesList[key].timeList.push(obj);
    },
    addCarClass() {
      this.item.carClasses.push(
        JSON.parse(JSON.stringify(this.item.carClasses[0]))
      );
    },
    addddd(v) {
      this.item.carClasses[0].classesList.push(
        JSON.parse(JSON.stringify(this.item.carClasses[0].classesList[0]))
      );
    },
    delddd(index, key) {
      if (key == 0) {
        this.addddd();
      } else {
        this.item.carClasses[index].classesList.splice(key, 1);
      }
    },
  },
};
</script>
<style lang="">
#carClass123 {
  width: 100%;
  padding: 10px;
}
#carClass123 thead,
#carClass123 tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
#carClass123 thead {
  width: calc(100% - 1em);
}
#carClass123 tbody {
  display: block;
  height: calc(100% - 32px);
  overflow-y: auto;
  border-top: solid 1px #ccc;
  padding-top: 10px;
}
#carClass123 thead tr {
  background: #f1f1f1;
  height: 36px;
}
#carClass123 tbody tr {
  padding-bottom: 20px;
}
#carClass123 ul#wewewe {
  margin: 10px;
  position: relative;
}

#carClass123 ul#wewewe li i {
  font-size: 18px;
  margin-left: 4px;
  margin-right: 4px;
}
#carClass123 ul#wewewe li span {
  line-height: 30px;
  margin: auto 4px;
}
#carClass123 ul#wewewe li .asewec {
  width: 230px;
  float: left;
}
#carClass123 ul#wewewe li .asewec .asewec-child {
  display: flex;
  width: 100%;
}
#carClass123 ul#wewewe li .asewec123 {
  display: flex;
  width: 200px;
  float: left;
  margin-left: 10px;
}
#carClass123 ul#wewewe li .asewec1 {
  width: 50px;
  float: left;
}
#carClass123 ul#wewewe li .asewec2 {
  width: 40px;
  float: left;
}
#carClass123 ul#wewewe li .lyformitem label {
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/garbage/paibanTool.vue